import { render } from "./ReviewDetailModal.vue?vue&type=template&id=a904abd6&scoped=true"
import script from "./ReviewDetailModal.vue?vue&type=script&lang=js"
export * from "./ReviewDetailModal.vue?vue&type=script&lang=js"

import "./ReviewDetailModal.vue?vue&type=style&index=0&id=a904abd6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a904abd6"]])

export default __exports__